// Components
import { useCallback, useEffect } from 'react';
import DiscardConfirmation, {
  useDiscardConfirmation,
} from 'components/DiscardConfirmation';
// Utils
import { getText } from 'i18n/intl';
import { useAppDispatch } from 'slices/store';
// Slices
import {
  checkTimeZoneSaveDisabled,
  fetchDsts,
  fetchTimeZones,
  fetchZones,
} from 'slices/timeZone.slice';
import { DefaultContentLayout } from '@timeedit/ui-components';
import TimeZoneDrawer from './TimeZoneDrawer';
import TimeZoneList from './TimeZoneList';

const TimeZonePage = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchTimeZones());
    dispatch(fetchZones());
    dispatch(fetchDsts());
  }, []);

  const [
    openDiscardDialog,
    onCloseDiscardDialog,
    confirmFn,
    confirmDiscardChanged,
  ] = useDiscardConfirmation();

  const confirmDiscardPaddingChanges = useCallback(
    (isFirstDrawer: boolean, actionFn: () => void) => {
      const isFieldRelationDisabled = dispatch(
        checkTimeZoneSaveDisabled(isFirstDrawer)
      );
      if (!isFieldRelationDisabled) {
        return confirmDiscardChanged(actionFn);
      }
      actionFn();
    },
    []
  );

  return (
    <DefaultContentLayout
      title={getText('time_zones')}
      subtitle={getText('time_zones_subtitle')}
    >
      <div className="inner-content--wrapper">
        <TimeZoneList
          confirmDiscardPaddingChanges={confirmDiscardPaddingChanges}
        />
        <TimeZoneDrawer
          confirmDiscardPaddingChanges={confirmDiscardPaddingChanges}
        />
      </div>
      <DiscardConfirmation
        open={openDiscardDialog}
        onClose={onCloseDiscardDialog}
        confirmFn={confirmFn}
      />
    </DefaultContentLayout>
  );
};

export default TimeZonePage;
